var React = require('react');

function SacADos (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 10a6 6 0 0 1 12 0v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z","key":0}),React.createElement("path",{"d":"M10 4.3V3.5a2 2 0 0 1 4 0v.8","key":1}),React.createElement("path",{"d":"M8.5 21v-5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5","key":2}),React.createElement("path",{"d":"M8.5 18h7","key":3})]);
}

SacADos.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = SacADos;

SacADos.default = SacADos;
